import { IPendingPostPayment, IPostPayment } from '../../data/entities/post-payment/index';
import { ActionTypeNames, ActionValues, createActionCreators } from '../../store/actions';
import { ThunkAction } from '../../store/middleware';

const postPaymentQueueActions = createActionCreators<
	{ T: 'POST_PAYMENT_CREATE_QUEUE', P: IPendingPostPayment },
	{ T: 'POST_PAYMENT_CREATE_QUEUE_CLEAR' }
	>(
		'POST_PAYMENT_CREATE_QUEUE',
		'POST_PAYMENT_CREATE_QUEUE_CLEAR'
	);

const postPaymentCreateActions = createActionCreators<
	{ T: 'POST_PAYMENT_CREATE_REQUEST' },
	{ T: 'POST_PAYMENT_CREATE_RECEIVE', P: { postPayments: IPostPayment[] } },
	{ T: 'POST_PAYMENT_CREATE_FAILURE', P: { error: Error } }
	>(
		'POST_PAYMENT_CREATE_REQUEST',
		'POST_PAYMENT_CREATE_RECEIVE',
		'POST_PAYMENT_CREATE_FAILURE'
	);

const postPaymentDeleteActions = createActionCreators<
	{ T: 'POST_PAYMENT_DELETE', P: IPostPayment },
	{ T: 'POST_PAYMENT_DELETE_RECEIVE', P: { id: number } },
	{ T: 'POST_PAYMENT_DELETE_FAILURE', P: { id: number, error: Error }}
	>(
		'POST_PAYMENT_DELETE',
		'POST_PAYMENT_DELETE_RECEIVE',
		'POST_PAYMENT_DELETE_FAILURE'
	);

export const createPostPayment = (postPayments: IPostPayment[], propertyId: string, eventId: string): ThunkAction<any> =>
	async (dispatch, getState, { _deprecatedApi: api }) => {
		dispatch(postPaymentCreateActions.POST_PAYMENT_CREATE_REQUEST());
		try {
			const response = await api.postPayments.createPostPayment(postPayments, propertyId, eventId);

			dispatch(postPaymentCreateActions.POST_PAYMENT_CREATE_RECEIVE({ postPayments: response.postPayments! }));
			dispatch(postPaymentQueueActions.POST_PAYMENT_CREATE_QUEUE_CLEAR());
		} catch (error) {
			dispatch(postPaymentCreateActions.POST_PAYMENT_CREATE_FAILURE({ error }));
		}
	};

export const queuePostPayment = (action: 'add' | 'remove', postPayments: IPostPayment[], eventId: string): ThunkAction<any> =>
	async (dispatch, getState, { _deprecatedApi: api }) => {
		for (const payment of postPayments) {
			dispatch(postPaymentQueueActions.POST_PAYMENT_CREATE_QUEUE({ action, payment, eventId }));
		}
	};

export const clearPostPaymentQueue = (): ThunkAction<any> =>
	async (dispatch, getState, { _deprecatedApi: api }) => {
		dispatch(postPaymentQueueActions.POST_PAYMENT_CREATE_QUEUE_CLEAR());
	};

export const deletePostPayment = (postPayment: IPostPayment, propertyId: string, eventId: string): ThunkAction<any> =>
	async (dispatch, getState, { _deprecatedApi: api }) => {
		dispatch(postPaymentDeleteActions.POST_PAYMENT_DELETE());
		try {
			await api.postPayments.deletePostPayment(postPayment.id!, propertyId, eventId);

			dispatch(postPaymentDeleteActions.POST_PAYMENT_DELETE_RECEIVE({ id: postPayment.id! }));
		} catch (error) {
			dispatch(postPaymentDeleteActions.POST_PAYMENT_DELETE_FAILURE({ id: postPayment.id!, error }));
		}
	};

const actions = { ...postPaymentQueueActions, ...postPaymentCreateActions, ...postPaymentDeleteActions };

type PostPaymentActions = ActionValues<typeof actions>;
type PostPaymentActionTypes = ActionTypeNames<PostPaymentActions>;
export type Actions = PostPaymentActions[keyof PostPaymentActions];
export const ActionTypes = Object.keys(actions).reduce((types, t) => {
	types[t] = t;
	return types;
}, {} as PostPaymentActionTypes);
